import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ProfessionForm from './ProfessionForm';

const ProfessionActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ProfessionCreate = (props: any) => {
  return (
    <Create actions={<ProfessionActions {...props} />} {...props}>
      <ProfessionForm />
    </Create>
  );
};

export default ProfessionCreate;
